import React, { useContext, useRef, useEffect, useState } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";

const SectionSpacingHandle = (props) => {
  const handle = useRef(null);
  const [contextData] = useContext(VariantContextData);

  const direction = props.direction;
  const directionCapitalized =
    direction == "top"
      ? "Top"
      : direction == "bottom"
      ? "Bottom"
      : direction == "left"
      ? "Left"
      : "Right";
  const section = props.section;
  const isMobile = contextData.device == "mobile";
  const sectionDivSelector = `#builder .cf-section[data-section-id="${section.id}"]`;
  const sectionContainerSelector = `#builder .cf-section-container[data-section-id="${section.id}"]`;
  const defaultValue =
    !isMobile || _.isNil(section.options['structure'][`container-padding-mobile-${direction}`])
      ? section.options['structure'][`container-padding-${direction}`]
      : section.options['structure'][`container-padding-mobile-${direction}`];
  const [value, setValue] = useState(defaultValue);

  const handleDrag = (e) => {
    e.preventDefault();

    let oldValue;
    let newValue;
    const sectionDiv = document.querySelector(sectionDivSelector);
    const sectionContainer = document.querySelector(sectionContainerSelector);
    const style = window.getComputedStyle(sectionContainer);

    if (direction == "top") {
      oldValue = parseInt(style[`paddingTop`].replace(" !important", "") || 0);
      newValue = oldValue + e.movementY;
    }

    if (direction == "bottom") {
      oldValue = parseInt(style[`paddingBottom`].replace(" !important", "") || 0);
      newValue = oldValue + e.movementY;
    }

    if (direction == "left") {
      oldValue = parseInt(style[`paddingLeft`].replace(" !important", "") || 0);
      newValue = oldValue + e.movementX;
    }

    if (direction == "right") {
      oldValue = parseInt(
        style[`paddingRight`].replace(" !important", "") || 0
      );
      newValue = oldValue - e.movementX;
    }

    if (newValue >= 0) {
      sectionContainer.style.setProperty(
        `padding-${direction}`,
        `${newValue}px`,
        "important"
      );
      sectionDiv.classList.add("spacing");
      setValue(newValue);
    }
  };

  const handleUpdate = () => {
    document.removeEventListener("mousemove", handleDrag);
    document.removeEventListener("mouseup", handleUpdate);

    const sectionDiv = document.querySelector(sectionDivSelector);
    const sectionContainer = document.querySelector(sectionContainerSelector);
    const newPosition = parseInt(
      sectionContainer.style[`padding${directionCapitalized}`]
        .replace("px", "")
        .replace(" !important", "")) || 0;

    sectionContainer.style.removeProperty(`padding-${direction}`);
    sectionDiv.classList.remove("spacing");

    dispatchCustomEvent("updateBuilder", {
      updates: [
        {
          object_type: "sections",
          object_id: section.id,
          setting_name: `[options][structure][container-padding${
            isMobile ? "-mobile" : ""
          }-${direction}]`,
          value: newPosition,
          old_value: defaultValue,
        },
      ],
    });
  };

  const syncSpacingHandleFromContext = function () {
    // Automatically update the value from the context when changing the device
    const desktopValue = section.options['structure'][`container-padding-${direction}`];
    const mobileValue = section.options['structure'][`container-padding-mobile-${direction}`];

    if (isMobile && mobileValue) {
      setValue(parseInt(mobileValue));
    } else if (desktopValue) {
      setValue(parseInt(desktopValue));
    }
  }

  useEffect(() => {
    syncSpacingHandleFromContext();
  }, [contextData.device]);

  return (
    <div
      ref={handle}
      className="section-spacing-wrapper"
      style={{
        display: contextData.selected_object_type == "sections" && contextData.selected_object_id == section.id && !contextData.selected_object_collapse ? "flex" : "none",
        position: "absolute",
        top: ["left", "right"].includes(direction) ? 0 : undefined,
        left: ["top", "bottom"].includes(direction) ? 0 : undefined,
        right: ["top", "bottom"].includes(direction) ? 0 : undefined,
        [direction]: 0,
        width: direction === "top" || direction === "bottom" ? "100%" : "10px",
        height: direction === "left" || direction === "right" ? "100%" : "10px",
        cursor:
          direction === "top" || direction === "bottom"
            ? "ns-resize"
            : "ew-resize",
        zIndex: 10,
        justifyContent: "center",
        alignItems: "center",
      }}
      onMouseDown={(e) => {
        document.addEventListener("mousemove", handleDrag);
        document.addEventListener("mouseup", handleUpdate);
      }}
    >
      <div
        className={`section-spacing-handle !w-[25px] !min-w-[25px] !h-[7px] bg-white shadow border-solid border-[1px] border-slate-300 rounded ${
          ["left", "right"].includes(direction) ? "rotate-90" : ""
        } ${
          direction == "top"
            ? "mt-[-2px]"
            : direction == "bottom"
            ? "mb-[-2px]"
            : direction == "left"
            ? "ml-[-2px]"
            : "mr-[-2px]"
        }`}
      ></div>
      <div className={`hidden section-spacing-value text-xl opacity-80 ${direction == 'top' ? 'mt-[10px]' : direction == 'bottom' ? 'mb-[10px]' : direction == 'left' ? 'ml-[30px]' : 'mr-[30px]'}`}>
        {`${value || 0}px`}
      </div>
    </div>
  );
};

export default SectionSpacingHandle;
